import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import * as html2pdf from 'html2pdf.js';
import * as _ from 'lodash';

@Component({
  selector: 'app-uiform-view',
  templateUrl: './uiform-view.component.html',
  styleUrls: ['./uiform-view.component.css']
})
export class UiformViewComponent extends BaseListCtl {
  @Input() appId: number = 0;
  @Input() usecaseId: number | null = 0;
  @Input() uiformId: number | null = 0; // pass as a input 
  @Input() id: number | null = 0;


  // @ViewChild('content')
  // content!: ElementRef;
  //@ViewChild('chart') imageElement!: ElementRef;

  public usecaseSchema: any = {
  };

  public attributeId: number = 0;

  public entryform: any = {
    data: { id: 0 }, //form data
  };


  public searchform: any = {

    data: {}

  };

  public shareform: any = {
    data: {}, //form data
  };

  imagePreview: string | ArrayBuffer | null = null;

  constructor(public override locator: ServiceLocatorService, public override route: ActivatedRoute, public httpClient: HttpClient) {
    super("", locator, route);
    let _self = this;


    _self.locator.config
    .getProperty('endpoint.ui.forms')
    .then((property: string) => {
      _self.initApiEndpoint(property);
    });

    if (route.snapshot.paramMap.get('appId'))
      _self.appId = Number(route.snapshot.paramMap.get('appId'));

    if (route.snapshot.paramMap.get('usecaseId'))
      _self.usecaseId = Number(route.snapshot.paramMap.get('usecaseId'));

    if (route.snapshot.paramMap.get('uiformId'))
      _self.uiformId = Number(route.snapshot.paramMap.get('uiformId'));

    if (route.snapshot.paramMap.get('id'))
      _self.id = Number(route.snapshot.paramMap.get('id'));

  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.title = data.title;
    form.subtitle = data.subtitle;
    form.description = data.description;
    form.userstoryId = data.userstoryId;
    form.code = data.code;
    form.description = data.description;
    form.columns = data.columns;
    form.fields = data.fields;
    form.readOnly = data.readOnly;
    if (data.buttons) {
      form.buttons = data.buttons;
    }

    if (data.inputs) {
      form.inputs = data.inputs;
    }
  }



  override ngOnInit() {
    let _self = this;
    if (_self.uiformId)
      this.get(_self.uiformId, function () {
        _self.usecaseId = _self.form.data.userstoryId
        console.log(_self.form);
        _self.getUsecaseSchema();
      })

  }


  getAttributeLable(lable: string) {

  }




  public attributeList: any = [];

  public getUsecaseSchema() {
    let _self = this;
    let url = _self.locator.config.get("endpoint.userstory") + "/get/" + _self.usecaseId;
    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert("Server Error:" + error);
        return;
      }
      _self.usecaseSchema = res.result.data;
      _self.attributeId = _self.usecaseSchema['appId']
      console.log("usecaseSchema", _self.usecaseSchema);
      _self.getUsecasePreloadData();

      if (_self.id) {
        _self.getUiformData(_self.id)
      }

    });
    let attrUrl = _self.locator.config.get("endpoint.userstory.attributes") + "/list/" + _self.usecaseId;
    //{ userstoryId: _self.usecaseId },
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      _self.attributeList = res.result.data;
    });



  }
  /**
  * Get usecase preload data
  */
  public getUsecasePreloadData() {
    let _self = this;
    let url = _self.getAPIBaseUrl("preload");
    //let url = _self.locator.endpoints.CD_DATA + "/" + _self.usecaseName + "/preload";
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert("Server Error:" + error);
        return;
      }
      _self.form["preload"] = res.result;
    });
  }


  /**
* Get usecase record by primary key
* @param id 
*/
  public getUiformData(id: number) {

    let _self = this;
    if (!(id > 0)) {
      return;
    }

    let url = _self.getAPIBaseUrl("get") + "/" + id;
    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert("Server Error:" + error);
        return;
      }
      _self.entryform["data"] = res.result["data"];
    });
    _self.getUsecasePreloadData();
  }

  /**
   * Get API base URL
   * @returns 
   */
  getAPIBaseUrl(suburl?: string) {
    let _self = this;
    let updatedName = _self.usecaseSchema['collectionName'].replace(/\./g, '/');
    let url = _self.locator.config.get('endpoint.api.v1') + '/' + updatedName;
    if (suburl) {
      url += '/' + suburl;
    }
    return url;
  }

  public saveUiformData() {
    let _self = this;
    // _self.entryform["error"] = [];
    // _self.entryform["message"] = "";
    // _self.entryform["inputerror"] = [];

    let url = _self.urlRewrite(_self.getAPIBaseUrl("save"));
    _self.locator.http.post(url, _self.entryform["data"], function (res: any, error: boolean) {
      if (error) {
        alert("Server Error:" + error);
        return;
      }
      _self.entryform["error"] = !res.success;
      _self.entryform["message"] = res.message;
      _self.entryform["inputerror"] = res.result["inputerror"];
      if (res.success) {
        _self.entryform["data"]["id"] = res.result["data"]["id"];

      }
    });
  }

  public onChange(e: any, val: any) {
    let _self = this;
    let l = _self.form.preload[e['primaryUsecase']];
    let col = e['depAttribute'];
    for (let i = 0; i < l.length; i++) {
      if (l[i]["id"] == val.target.value) {
        _self.entryform.data[col] = l[i]["name"];
        //alert(_self.form.data[col]);
      }
    }
    //alert(val.target.value);
  }


  urlRewrite(endpoint: string) {
    let keySuffix = this.locator.config.get("CONTEXT_PATH") + "-";
    let sid = localStorage.getItem(keySuffix + 'sessionId');
    //  let sid = localStorage.getItem(GlobalConstants.getKey('sessionId'));
    if (!sid) {
      sid = "0";
    }
    endpoint = endpoint + ";jsessionid=" + sid;
    return endpoint;
  }

  onSave() {
    //this.entryform.data['uiformId'] = this.form.data['id'];
    this.saveUiformData();
  }


  onCancel() {
    // nothing do  
    this.forward('/uiform/' + this.uiformId);
  }

  onList() {
    // go to list page 
    this.forward('/uiformlist/' + this.uiformId);
  }

  onDelete() {

  }

  onNew() {
    this.resetUiformData();
  }

  resetUiformData() {
    let _self = this;
    _self.entryform["data"] = {}

  }


  public getInputType(t: string) {
    if (t === 'date') {
      return t;
    } else if (t === 'number' || t === 'decimal') {
      return 'number';
    } if (t === 'text') {
      return 'text';
    } if (t === 'date') {
      return t;
    }
    if (t === 'time') {
      return t;
    }
    if (t === 'file') {
      return t;
    }
    if (t === 'textarea') {
      return t;
    }

    else {
      return 'text';
    }
  }

  getAttributeById(fieldId: number) {
    return this.attributeList.find((attr: any) => attr.id === fieldId && attr['system'] != 1);
  }

  getAttributeByUniqueId(fieldId: number) {
    return this.attributeList.find((attr: any) => attr.id === fieldId && attr['system'] != 1 && attr['unique'] == 1);
  }


  isAttributeHaveUnique() {
    return this.attributeList.find((attr: any) => attr['unique'] == 1);
  }


  resetSearchValue() {
    let _self = this;
    _self.searchform.data = {};
    _self.entryform = {};
  }

  resetShareForm() {
    let _self = this;
    _self.shareform.data = {};  
  }

  /**
* get usecase records list
*/
  public getSearchUiformDataByList() {
    let _self = this;
    console.log(this.searchform.data)
    const hasAtLeastOneValue = Object.values(this.searchform.data).some(
      value => value !== null && value !== undefined && value !== ''
    );

    if (!hasAtLeastOneValue) {
      _self.entryform = {};
      return;
    }
    console.log(hasAtLeastOneValue); // true if there's at least one non-empty value, false otherwise

    let url = _self.getAPIBaseUrl() + "/search";
    _self.locator.http.post(url, this.searchform.data, function (res: any, error: boolean) {
      if (error) {
        //alert("Server Error:" + error);
        _self.entryform['error'] = true;
        _self.entryform['message'] = error;
        return;
      }
      if (res.result["data"].length > 0) {
        _self.entryform.data = res.result["data"][0];

      } else {
        _self.entryform['error'] = true;
        _self.entryform['message'] = "No record found";
        _self.entryform = {};
      }
    });

  }

  fieldButtonSubmit(button: string) {
    let _self = this;
    if (button === 'save') {
      _self.onSave();
    }
    if (button === 'cancel') {
      _self.onCancel();
    }

    if (button === 'list') {
      _self.onList();
    }

    if (button === 'delete') {
      _self.onDelete();
    }

    if (button === 'new') {
      _self.onNew();
    }
    console.log(this.entryform)
  }


  public getInputError(name: string) {
    let _self = this;
    let errMsg = "";
    let ie = _self.entryform["inputerror"];
    if (ie && ie[name]) {
      errMsg = ie[name];
    }
    return errMsg;
  }

  /**
* Upload Image 
* @param event 
*/
  /**
   * 
   * @param event 
   * @param code 
   * @param imageId 
   */
  public onFileChanged(event: any, code: string, imageId: any) {
    console.log(code);
    const fileObj = event.target.files[0];
    var _self = this;
    _self.showPreview(event);
    console.log(_self.form.data['code'])
    if (imageId === null || imageId === undefined) {

      imageId = 0;
      //alert(_self.entryform.data['id'])
    }
    let url = _self.getAPIBaseUrl("doc/" + _self.entryform.data['id'] + "/" + imageId + "/" + code);
    var param = {
      id: _self.id
    };
    this.locator.http.postMutipart(url, param, fileObj, function (res: any, error: any) {
      if (error) {
        alert(error);
        return;
      }
      _self.form.error = !res.success;
      _self.form.message = res.result.message;
      if (res.success) {
        _self.entryform['message'] = "file is uploaded";
        _self.entryform.data[code] = res.result.data[code];
        _self.changeDoc();
        _self.getDocThumbnail(_self.entryform.data[code]);

      }
    });
    console.log("fileObj  ", fileObj);
  }
  // Method to get the icon class based on the key
  getButtonIcon(buttonKey: string): string {
    const icons: { [key: string]: string } = {
      save: 'fas fa-save',
      cancel: 'fas fa-times',
      delete: 'bx bxs-trash',
      list: 'fas fa-list',
      new: 'fa fa-plus',
    };
    return icons[buttonKey] || '';
  }

  // Method to get the button label based on the key
  getButtonLabel(buttonKey: string): string {
    const labels: { [key: string]: string } = {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      list: 'List',
      new: 'New',
    };
    return labels[buttonKey] || buttonKey;
  }


  /**
  * Get doc thumbnail
  * @param skey 
  */
  override getDocThumbnail(skey: number) {
    if (!skey) {
      skey = 0;
    }
    let docAPI = this.locator.config.get("DOC_API");

    return docAPI + "th/" + skey + "?t=" + this.imageTimestamp;;
  }

  /**
   * Get application doc
   * @param skey 
   */
  override getDoc(skey: number) {
    if (!skey) {
      skey = 0;
    }
    let docAPI = this.locator.config.get("DOC_API");

    return docAPI + skey + "?t=" + this.imageTimestamp;;
  }

  /**
   * Get the thumbnail of the image
   * @param logo
   * @returns
   */
  getDocThumbnailImage(logo: any) {
    return this.getDocThumbnail(logo);
  }



  /**
 * Show preview of the image
 * @param event
 */
  showPreview(event: Event) {
    const target = event.target as HTMLInputElement;
    const file = target.files ? target.files[0] : null;

    console.log("File from input:", file); // Logs the file object

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        console.log("File loaded, setting preview");
        this.imagePreview = reader.result as string; // Cast result to string
      };
      reader.onerror = (error) => {
        console.error("Error loading file:", error); // Log any errors with FileReader
      };
      reader.readAsDataURL(file); // Convert the file to a Base64 URL
    } else {
      console.warn("No file selected");
    }
  }


  public getPrimaryUsecase(attribute: any) {
    if (this.form.preload && attribute && attribute['primaryUsecase'] && this.form.preload[attribute['primaryUsecase']]) {
      return this.form.preload[attribute['primaryUsecase']]
    }

    return [];
  }



  downloadPDF() {
    // Options for PDF generation
    // const element = this.content.nativeElement;

    // // Wait for images to load
    // const images = Array.from(element.getElementsByTagName('img')) as HTMLImageElement[];
    // const promises = images.map((img) => {
    //   return new Promise<void>((resolve) => {
    //     if (img.complete) {
    //       resolve();
    //     } else {
    //       img.onload = () => resolve();
    //       img.onerror = () => resolve(); // Handle error
    //     }
    //   });
    // });

    // Promise.all(promises).then(() => {
    //   const options = {
    //     margin: 0.5,
    //     filename: 'document_with_image.pdf',
    //     image: { type: 'jpeg', quality: 0.98 },
    //     html2canvas: { scale: 2 },
    //     jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
    //   };

    //   html2pdf().from(element).set(options).save();
    // });
     
  }


  /**
 * Export data in PDF
 */
   public exportPDFData() {
    let _self = this;
    let url = _self.urlRewrite(_self.getAPIBaseUrl("downloadpdf/"+_self.entryform.data['id']+'/'+_self.uiformId));
    //let endpoint = this.httpService.urlRewrite(url);
    _self.httpClient.post(url, {}, { responseType: 'blob' }).subscribe((data: any) => {
      _self.downloadDataAsFile(data, "export.pdf");
    }, (data) => {
      console.error(data);
    });
  }

  /**
* Downalod data as file 
* @param data 
* @param fileName 
*/
  public downloadDataAsFile(data: any, fileName: string) {
    //Create a dynamic link and download file
    let file = new window.Blob([data], { type: data.type });
    const downloadAncher = document.createElement("a");
    downloadAncher.style.display = "none";
    const fileURL = URL.createObjectURL(file);
    downloadAncher.href = fileURL;
    downloadAncher.download = fileName;
    downloadAncher.click();
  }


  /**
   * Share PDF by Email
   */
  public sharePdf(){
    let _self=this;
    let url = _self.getAPIBaseUrl("sendForm/"+_self.entryform.data['id']+'/'+_self.uiformId)
    _self.locator.http.post(url, _self.shareform.data, function (res: any, error: boolean) {
      if (error) {       
        _self.shareform['error'] = true;
        _self.shareform['message'] = error;
        return;
      }
      if (res.success) {
        _self.shareform['message'] = res.message;      
      }
    });
  }


  getDescription(field:any){
    if(field['description']){
      return field['description'];
  }

    return field['label'];
  }

}
function ViewChild(arg0: string): (target: UiformViewComponent, propertyKey: "content") => void {
  throw new Error('Function not implemented.');
}




